import successIcon from '../../assets/icons/doneImg.png';
import appStore from '../../assets/icons/aapStore.png';
import googlePlay from '../../assets/icons/googlePlay.png';

const AppDownload = () => {
    return (
      <>
        <div className='download-app-container' >
          <div className='text-center' >
            <h3>Download the CoreVitals App</h3>
            <p>Track your results, view your history, and stay informed.</p>
          </div>
          <div className='download-app-buttons' >
            <a href="https://apps.apple.com/us/app/corevitals/id6746760510" target='_blank' rel='noreferrer'><img src={appStore} alt="" /></a>
            <a href="https://play.google.com/store/apps/details?id=me.corevitals.app&pli=1" target='_blank' rel='noreferrer'><img src={googlePlay} alt="" /></a>
          </div>
        </div> 
      </>
    )
  }

const Confirmation = () => {
    return (
        <div>
            <div className='booking-success-container' >
          <div className='booking-container' >
            <img src={successIcon} alt="Success" />
            <h2 className='text-center top-space' > Thank you for completing the onboarding form!</h2>
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
            
            </div>
            <AppDownload />
          </div>
          
          
        </div>
        </div>
    );
};

export default Confirmation;